<div class="animated fadeIn">

  <tabset>

    <!-- ===== TAB NEWS ===== -->
    <tab heading="News" (selectTab)="onSelectNewsTab()">
      <div class="card mt-3">
        <div class="card-header">
          <i class="fa fa-newspaper-o"></i> News
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add News
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Periodicity</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (newsIsLoading) {
                <tr>
                  <td colspan="8" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (newsList.length === 0) {
                <tr>
                  <td colspan="8" class="text-center text-muted">No news found.</td>
                </tr>
              } @else {
                @for (news of newsList; track $index; let i = $index) {
                  <tr>
                    <td>{{ (newsPageNumber - 1) * resultsPerPage + i + 1 }}</td>
                    <td>{{ news.newsId }}</td>
                    <td>{{ news.name }}</td>
                    <td>{{ news.startTimestamp !== 0 ? dateService.getDateFromatted(news.startTimestamp) : '-' }}</td>
                    <td>{{ news.endTimestamp !== 0 ? dateService.getDateFromatted(news.endTimestamp) : '-' }}</td>
                    <td>
                      @if (news.periodicity) {
                        <small>{{ getPeriodicityLabel(news) }}</small>
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                    <td>
                      @switch (getNewsStatus(news)) {
                        @case ('waiting') {
                          <span class="badge bg-info">Waiting</span>
                        }
                        @case ('in_progress') {
                          <span class="badge bg-success">In progress</span>
                        }
                        @case ('past') {
                          <span class="badge bg-danger">Past</span>
                        }
                        @case ('disabled') {
                          <span class="badge bg-secondary">Disabled</span>
                        }
                      }
                      @if (news.isRate) {
                        <span class="badge bg-warning ms-1">Rate</span>
                      }
                      @for (reward of news.rewards; track reward.rewardId) {
                        <span class="badge bg-secondary ms-1">
                          {{ getCurrencyTypeName(reward.currencyType) }} × {{ reward.currencyQuantity }}
                          @if (reward.currencyTicketCost > 0) {
                            ({{ reward.currencyTicketCost }} tickets)
                          }
                        </span>
                      }
                    </td>
                    <td>
                      <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickRewards(news)" tooltip="Rewards" placement="top"><i class="fa fa-gift"></i></button>
                      <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(news)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      @if (getNewsStatus(news) !== 'past') {
                        <button class="btn btn-sm me-1" type="button"
                          [class.btn-success]="!news.isActive"
                          [class.btn-warning]="news.isActive"
                          (click)="onClickToggleActive(news)"
                          [tooltip]="news.isActive ? 'Deactivate' : 'Activate'" placement="top">
                          <i class="fa" [class.fa-toggle-on]="news.isActive" [class.fa-toggle-off]="!news.isActive"></i>
                        </button>
                      }
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(news)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (newsPageNumber - 1) * resultsPerPage + 1 }} to {{ (newsPageNumber - 1) * resultsPerPage + newsList.length }} of {{ newsTotalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="newsPageNumber <= 1">
                <button class="page-link" (click)="onClickNewsPaginationPrevious()" [disabled]="newsPageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(newsPageNumber, newsTotalPages); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === newsPageNumber">
                    <button class="page-link" (click)="newsGoToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="newsPageNumber >= newsTotalPages">
                <button class="page-link" (click)="onClickNewsPaginationNext()" [disabled]="newsPageNumber >= newsTotalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </tab>

    <!-- ===== TAB PREDEFINED ===== -->
    <tab heading="Predefined" (selectTab)="onSelectPredefinedTab()">
      <div class="card mt-3">
        <div class="card-header">
          <i class="fa fa-list-alt"></i> Predefined News
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAddPredefined()">
              <i class="fa fa-plus"></i> Add Predefined News
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Name</th>
                <th>Translations</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (predefinedIsLoading) {
                <tr>
                  <td colspan="5" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (predefinedList.length === 0) {
                <tr>
                  <td colspan="5" class="text-center text-muted">No predefined news found.</td>
                </tr>
              } @else {
                @for (item of predefinedList; track item.newsPredefinedId; let i = $index) {
                  <tr>
                    <td>{{ (predefinedPageNumber - 1) * resultsPerPage + i + 1 }}</td>
                    <td>{{ item.newsPredefinedId }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.translations.length }}</td>
                    <td>
                      <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickPredefinedTranslations(item)" tooltip="Translations" placement="top"><i class="fa fa-language"></i></button>
                      <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEditPredefined(item)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeletePredefined(item)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (predefinedPageNumber - 1) * resultsPerPage + 1 }} to {{ (predefinedPageNumber - 1) * resultsPerPage + predefinedList.length }} of {{ predefinedTotalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="predefinedPageNumber <= 1">
                <button class="page-link" (click)="onClickPredefinedPaginationPrevious()" [disabled]="predefinedPageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(predefinedPageNumber, predefinedTotalPages); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === predefinedPageNumber">
                    <button class="page-link" (click)="predefinedGoToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="predefinedPageNumber >= predefinedTotalPages">
                <button class="page-link" (click)="onClickPredefinedPaginationNext()" [disabled]="predefinedPageNumber >= predefinedTotalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </tab>

    <!-- ===== TAB CONFIGURATIONS ===== -->
    <tab heading="Configurations">
      <app-configurations-block [configurations]="newsConfigurations" [collapsible]="false" />
    </tab>

  </tabset>
</div>

<app-news-add-modal #addModal></app-news-add-modal>
<app-news-edit-modal #editModal></app-news-edit-modal>
<app-news-rewards-modal #newsRewardsModal></app-news-rewards-modal>
<app-news-predefined-add-modal #predefinedAddModal></app-news-predefined-add-modal>
<app-news-predefined-edit-modal #predefinedEditModal></app-news-predefined-edit-modal>
<app-news-predefined-translations-modal #predefinedTranslationsModal></app-news-predefined-translations-modal>
